import React from "react";
import {SelectField} from "./FilterComponentStyles";

// Select boolean değer tutamadığı için option'lar string, dışarıya boolean/undefined dönülür.
const BooleanSelectFilter = ({
    title,
    trueLabel,
    falseLabel,
    value,
    onChange,
    hideTitle = false,
    marginBottom = "20px",
    ...props
}) => {
    const selectValue = typeof value === "boolean" ? String(value) : undefined;

    return (
        <React.Fragment>
            {!hideTitle && <h5>{title}</h5>}
            <SelectField
                data-testid="booleanSelect"
                value={selectValue}
                onChange={newValue =>
                    onChange(newValue === undefined ? undefined : newValue === "true")
                }
                allowClear={true}
                mb={marginBottom}
                {...props}
            >
                <SelectField.Option value="true" data-testid="booleanSelect_option">
                    {trueLabel}
                </SelectField.Option>
                <SelectField.Option value="false" data-testid="booleanSelect_option">
                    {falseLabel}
                </SelectField.Option>
            </SelectField>
        </React.Fragment>
    );
};

export default BooleanSelectFilter;
